import { SliderThumb as MuiSliderThumb, styled } from "@mui/material";

import { column } from "../layout";

export const SliderThumb = styled(MuiSliderThumb)(({ theme }) => ({
  "&&": {
    ...column,
    justifyContent: "space-evenly",
    backgroundColor: theme.palette.common.black,
    borderRadius: 0,
    boxShadow: "#ebebeb 0 2px 2px",
    width: theme.spacing(1),

    "&:focus, &:hover": {
      boxShadow: "#ccc 0 2px 3px 1px",
    },

    "& > .dot": {
      height: theme.spacing(0.375),
      width: theme.spacing(0.375),
      borderRadius: "50%",
      backgroundColor: theme.palette.common.white,
    },

    "&.Mui-disabled > .dot": {
      display: "none",
    },
  },
}));
